import { DownloadIcon } from '../../icons/DownloadIcon';

type DownloadButtonProps = {
  label: string;
  onClick?: () => void;
};

export const DownloadButton = ({ label, onClick }: DownloadButtonProps) => {
  return (
    <div
      className={`cursor-pointer flex items-center justify-center p-2 relative text-black no-underline`}
      onClick={onClick}
    >
      <span className={`h-5 ml-1 mr-3 w-5`}>
        <DownloadIcon />
      </span>
      <div className={`border-gray rounded-2xl border-solid border-2 transition-all inline-block py-1 px-2`}>
        {label}
      </div>
    </div>
  );
};
